import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Mercury Case Study | Canny';
const Description = 'Read about how Mercury uses Canny to improve efficiency and productivity.';
const Image = 'https://canny.io/images/468bba7765a7b99cf446df52f02c959d.jpg';
const MercuryUrl = 'https://canny.io/case-studies/mercury';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${MercuryUrl}#webpage`,
    url: MercuryUrl,
    name: 'Case Study: Mercury × Canny',
    description: 'How Mercury found a drastic improvement in efficiency and productivity.',
    inLanguage: 'en',
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createArticle('Article', {
    '@id': `${MercuryUrl}#article`,
    genre: 'Case Study',
    headline: 'How Mercury found a drastic improvement in efficiency and productivity',
    description:
      'Mercury replaced scattered tracking with Canny, creating a single source of truth for feedback. The team saw increased user input and drastically improved efficiency and productivity.',
    inLanguage: 'en',
    url: MercuryUrl,
    mainEntityOfPage: { '@id': `${MercuryUrl}#webpage` },
    author: {
      '@type': 'Organization',
      '@id': 'https://canny.io/#organization',
      name: 'Canny',
      url: 'https://canny.io',
    },
    publisher: { '@type': 'Organization', '@id': 'https://canny.io/#organization' },
    about: { '@type': 'Organization', name: 'Mercury', url: 'https://mercury.com' },
  }),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Case Studies', item: 'https://canny.io/case-studies' },
    { name: 'Mercury', item: MercuryUrl },
  ]),
]);

export default class MercuryLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: MercuryUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
